const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
/**
@example <remove-block
        v-if="isRemove"
        updateRemoveItem="onRemoveItem"
        updateRemoveClose="onRemoveClose"
        :preloader="preloader"
    ></remove-block>
 */
export default {
	components: {
		RemoveBlock
	},
	data: () => ({
		isRemove: false,
		removeId: null,
	}),
	methods: {
		getRemoveItem(id) {
			this.removeId = id;
			this.isRemove = true;
		},
		onRemoveClose() {
			this.isRemove = false;
		},
	}
};
